import { withStyles, makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

export const TakisBtn = withStyles(theme => ({
    root: {
        backgroundColor: theme.palette.purple,
        borderColor: theme.palette.yellow,
        borderStyle: 'solid',
        borderRadius: 0,
        borderWidth: '0.313rem',
        boxShadow: 'none',
        color: theme.palette.yellow,
        fontFamily: 'Veneer, Arial',
        fontSize: '2.5rem',
        lineHeight: 1,
        margin: '0.625rem',
        padding: "1rem",
        textTransform: 'none',
        transition: "all 0.35s",
        '& span': {
            zIndex: 2,
        },
        '&:after': {
            background: theme.palette.yellow,
            content: "''",
            height: '100%',
            left: '0',
            position: 'absolute',
            top: '0',
            transition: "all 0.15s",
            width: '0',
        },
        '&:hover': {
            borderColor: theme.palette.purple,
            color: theme.palette.purple,
            '&:after': {
                width: '100%',
            },
        },
        '&:focus': {
            backgroundColor: theme.palette.darkPurple,
            outlineWidth: '0.313rem',
            outlineStyle: 'solid',
            outlineColor: theme.palette.darkPurple,
        },
        '&.fauxActive': {
            backgroundColor: theme.palette.darkPurple,
            outlineWidth: '0.313rem',
            outlineStyle: 'solid',
            outlineColor: theme.palette.darkPurple,
        },
        '&:active': {
            backgroundColor: theme.palette.darkPurple,
            boxShadow: 'none',
        },
    },
    label: {
        lineHeight: "1",
        transform: "translateY(0.1875rem)",
    }
}))(Button);

export const colorVariations = makeStyles(theme => ({
    whiteButton: {
        borderColor: theme.palette.white,
        color: theme.palette.white,
        '&:hover': {
            backgroundColor: theme.palette.purple,
        },
        '&:focus': {
            backgroundColor: theme.palette.purple,
            outlineColor: theme.palette.purple,
        },
    },
    purpleButton: {
        backgroundColor: theme.palette.yellow,
        borderColor: theme.palette.purple,
        color: theme.palette.purple,
        '&:after': {
            background: theme.palette.purple,
        },
        '&:hover': {
            color: theme.palette.yellow,
            borderColor: theme.palette.white,
        },
        '&:focus': {
            backgroundColor: theme.palette.white,
            outlineColor: theme.palette.white,
        },
    },
    fullPurpleButton: {
        backgroundColor: theme.palette.purple,
        color: theme.palette.white,
        borderColor: theme.palette.purple,
        '&:hover': {
            color: theme.palette.purple,
            backgroundColor: theme.palette.whiteTransparent,
        },
        '&:focus': {
            color: theme.palette.purple,
            backgroundColor: theme.palette.white,
            outlineColor: theme.palette.white,
        },
    },
    purpleWhiteButton: {
        color: theme.palette.purple,
        borderColor: theme.palette.purple,
        '&:hover': {
            backgroundColor: theme.palette.yellow,
        },
        '&:focus': {
            backgroundColor: theme.palette.yellow,
            outlineColor: theme.palette.yellow,
        },
    },
    yellowPurpleButton: {
        color: theme.palette.yellow,
        borderColor: theme.palette.yellow,
        backgroundColor: theme.palette.darkPurple,
        '&:hover': {
            backgroundColor: theme.palette.purple,
        },
        '&:focus': {
            backgroundColor: theme.palette.purple,
            outlineColor: theme.palette.purple,
        },

    },
    disabled: {
        opacity: '70%'
    },
    tiltedLeft: {
        transition: '.5s ease',
        transform: 'perspective(62.5rem) rotate(8deg)'
    },
    tiltedLeftHover: {
        '&:hover': {
            transition: '.5s ease',
            transform: 'perspective(62.5rem) rotate(8deg)'
        }
    },
    amazonBtn: {
        padding: '0',
        margin: '0 .5rem',
        '& span': {
            transform: 'unset',
        },
        '& img': {
            width: '8rem'
        }
    }
  }));
